import React from 'react'
import ProductsHero from '../components/products/ProductsHero'
import BestSellingProducts from '../components/home/BestSellingProducts'
import SEO from '../components/seo/SEO'

export default function Products() {
  return (
    <>
      <SEO
        title="Products | Custom Logo Door Mats Zambia - Best Selling Mats"
        description="Browse our best selling custom logo door mats in Zambia. Marshall Scribe, Novamat, Super Deco and more. Large, thin, washable, and heavy-duty door mats available. Request a quote today!"
        keywords="door mat products Zambia, custom logo mats, Marshall Scribe mats, Novamat door mats, Super Deco mats, large door mats, thin door mats, washable mats, heavy duty mats, best selling door mats"
        url="https://www.logobrandeddoormats.co.zm/products"
        image="https://www.logobrandeddoormats.co.zm/images/sectionimages/products hero.png"
      />
      <ProductsHero />
      <BestSellingProducts />
    </>
  )
}
